import { AppProvider } from "../Components/CommonComponents/ResizeTable/ResizeTable";

const ContextProviders = ({ children }) => {
  return <AppProvider>{children}</AppProvider>;
};

export default ContextProviders;
